import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Smooth Scroll (Lenis 1.3.x)
 * ----------------------------------------------------------------------------
 * Interpolazione morbida dello scroll tramite Lenis. Bridge con GSAP/ScrollTrigger
 * via lenis.on('scroll', ScrollTrigger.update) + gsap.ticker.
 *
 * Disabilitato su:
 *  - touch device (hover: none, pointer: coarse) → iOS Safari ha già inerziale
 *  - prefers-reduced-motion → accessibilità
 *  - WP admin (Gutenberg editor)
 *
 * Esporta lenisStop() / lenisStart() globalmente via window.__lenis per
 * eventuale integrazione con scroll-lock (es. apertura mobile menu).
 *
 * Configurazione:
 *  - duration: 1.8 (scroll prolungato per sensazione "vellutata")
 *  - easing: easeOutQuart (frenata dolce, decelerazione finale morbida)
 *  - anchors: true (gestione nativa <a href="#section">)
 *  - smoothWheel: true
 */

const isTouchDevice = () =>
  window.matchMedia("(hover: none), (pointer: coarse)").matches;

const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const initSmoothScroll = () => {
  // Skip su touch, reduced-motion, WP admin
  if (isTouchDevice() || prefersReducedMotion()) return;
  if (document.body.classList.contains("wp-admin")) return;

  const lenis = new Lenis({
    duration: 1.2,
    easing:    t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // expo out
    smoothWheel: true,
    anchors: true, // gestione automatica <a href="#section">
    wheelMultiplier: 1.0,
  });

  // Bridge con ScrollTrigger: ogni scroll Lenis aggiorna ST
  lenis.on("scroll", ScrollTrigger.update);

  // Ticker GSAP: ogni tick fa avanzare Lenis (no rAF separato)
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // GSAP usa secondi, Lenis ms
  });
  gsap.ticker.lagSmoothing(0); // no lag smoothing → scroll preciso

  // Esposizione globale per integrazione (es. mobile menu, modals)
  window.__lenis = lenis;
};

/**
 * Stop Lenis: blocca lo scroll (es. quando apre modal/menu).
 * Safe se Lenis non è inizializzato (touch device).
 */
export const lenisStop = () => {
  if (window.__lenis) window.__lenis.stop();
};

/**
 * Resume Lenis dopo stop().
 */
export const lenisStart = () => {
  if (window.__lenis) window.__lenis.start();
};

export default () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSmoothScroll);
  } else {
    initSmoothScroll();
  }
};
